import React, { FC } from 'react'
import Touchable from '@sport1/react-elements/Touchable'
import NonFlexingContainer from '../../Layouts/NonFlexingContainer'
import PlayHighlight from '../Match/HelperClass/PlayHighlight'

export type HighlightRowProps = {
    /**
     * callback when the row gets pressed
     * @TJS-Type function
     */
    onPress?: () => void
    /**
     * link to be opened when the row gets pressed
     */
    href?: string
    /**
     * text to be displayed
     */
    text?: string
    /**
     * spacer on top of the component
     */
    marginTop?: number | number[] | string | string[]
    /**
     * spacer on bottom of the component
     */
    marginBottom?: number | number[] | string | string[]
}

const HighlightRow: FC<HighlightRowProps> = ({ onPress, href, text, marginTop, marginBottom }) => (
    <NonFlexingContainer centerHorizontal marginTop={marginTop} marginBottom={marginBottom}>
        <Touchable onPress={onPress} href={href}>
            <PlayHighlight text={text} />
        </Touchable>
    </NonFlexingContainer>
)

export default HighlightRow
